import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = [
    'messageType',
    'organizationId',
    'assignEl',
    'informEl',
    'closeAssignElBtn',
    'assignElBtn',
    'informElBtn',
    'closeInformElBtn',
    'supportContent',
    'feedbackContent',
    'patientContent',
    'patientSelect',
    'actOnBehalfContainer',
  ];

  static values = {
    ambikiOrgId: String,
    url: String,
  };

  // Initialize act on behalf visibility based on the current organization and message type
  connect() {
    this.updateActOnBehalfVisibility();
  }

  toggleAssignView() {
    this.assignElTarget.classList.toggle('d-none');
    this.assignElBtnTarget.classList.toggle('d-none');
    this.closeAssignElBtnTarget.classList.toggle('d-none');
  }

  toggleInformView() {
    this.informElTarget.classList.toggle('d-none');
    this.informElBtnTarget.classList.toggle('d-none');
    this.closeInformElBtnTarget.classList.toggle('d-none');
  }

  // Show support or feedback content based on the message category type
  typeChange() {
    this.supportContentTarget.classList.toggle('d-none');
    this.feedbackContentTarget.classList.toggle('d-none');
    this.updateActOnBehalfVisibility();

    // Clear the "act on behalf" field when changing message type to non-support
    if (this.messageTypeTarget.value !== 'support') {
      this.clearActOnBehalfField();
    }
  }

  // Handle organization change:
  // 1. Toggle patient select dropdown visibility based on selected organization
  // 2. Clear patient selection if applicable
  // 3. Update act on behalf container visibility
  orgChange(event) {
    const selectedOrgId = event.target.selectize.getValue();
    this.patientContentTarget.classList.toggle('d-none', selectedOrgId !== this.currentOrgId);

    if (this.hasPatientSelectTarget && this.patientSelectTarget.selectize) {
      this.patientSelectTarget.selectize.clear();
      this.patientSelectTarget.selectize.clearOptions();
    }

    this.updateActOnBehalfVisibility();
  }

  // Hide act on behalf container if the organization is not Ambiki or the message type is not support
  updateActOnBehalfVisibility() {
    if (this.hasActOnBehalfContainerTarget) {
      const isAmbikiOrg = this.organizationIdTarget.value === this.ambikiOrgIdValue;
      const isSupport = this.messageTypeTarget.value === 'support';

      this.actOnBehalfContainerTarget.classList.toggle('d-none', !(isAmbikiOrg && isSupport));

      // Clear the "act on behalf" field when hiding it
      if (!(isAmbikiOrg && isSupport)) {
        this.clearActOnBehalfField();
      }
    }
  }

  clearActOnBehalfField() {
    const actOnBehalfContainer = document.getElementById('message_act_on_behalf_user_id').closest('.form-group');
    const clearButton = actOnBehalfContainer.querySelector('.autocomplete-clear-btn');

    if (clearButton) {
      clearButton.click();
    } else {
      throw new Error('Autocomplete clear button not found for act on behalf field');
    }
  }
}
